module.exports = __webpack_public_path__ + "static/img/login_bg.321ed9d0.jpg";